import SvgIcon from "@mui/material/SvgIcon";

export const AdminsIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#fff"
        strokeWidth="2"
        d="M13.5 11.5h-3A3.504 3.504 0 017 8V6.5a5 5 0 1110 0V8a3.504 3.504 0 01-3.5 3.5zm-1.5-9a4.004 4.004 0 00-4 4V8a2.503 2.503 0 002.5 2.5h3A2.503 2.503 0 0016 8V6.5a4.004 4.004 0 00-4-4zM4 23.5H3v-1a9.01 9.01 0 019-9h1v1h-1a8.009 8.009 0 00-8 8v1z"></path>
      <g fill="#fff" clipPath="url(#clip0_32394_12773)">
        <path d="M18.03 16.879c-1.182 0-2.122.94-2.122 2.121 0 1.182.94 2.121 2.121 2.121 1.182 0 2.122-.94 2.122-2.12 0-1.183-.94-2.122-2.122-2.122zm0 3.636A1.5 1.5 0 0116.513 19a1.5 1.5 0 011.515-1.515A1.5 1.5 0 0119.545 19a1.5 1.5 0 01-1.516 1.515z"></path>
        <path d="M22.485 18l-.849-.273-.182-.454.425-.788a.51.51 0 00-.091-.576l-.727-.727a.51.51 0 00-.576-.091l-.788.424-.455-.182-.273-.848a.492.492 0 00-.454-.334h-1.03a.425.425 0 00-.424.364l-.273.848c-.182.03-.334.091-.485.182l-.788-.424a.51.51 0 00-.576.091l-.727.727a.51.51 0 00-.09.576l.393.758c-.06.151-.121.333-.182.484l-.848.273a.492.492 0 00-.334.455v1.03c0 .212.152.394.364.454l.848.273.182.455-.424.788a.51.51 0 00.091.576l.727.727a.51.51 0 00.576.09l.788-.424.454.182.273.879c.06.182.243.333.455.333h1.03a.492.492 0 00.454-.333l.273-.879.455-.182.788.425a.51.51 0 00.576-.091l.727-.727a.51.51 0 00.09-.576l-.424-.788.182-.455.879-.273a.492.492 0 00.333-.454v-1.03a.519.519 0 00-.363-.485zm-.243 1.424l-1.09.333-.03.152-.274.636-.09.152.545 1-.606.606-1-.546-.152.091a2.876 2.876 0 01-.636.273l-.152.03-.333 1.091h-.848l-.334-1.09-.151-.03-.637-.274-.151-.09-1 .545-.606-.606.545-1-.09-.152a2.876 2.876 0 01-.273-.636l-.03-.152-1.092-.333v-.848l1.03-.303.061-.152c.06-.242.152-.454.273-.667l.091-.151-.515-1 .606-.606.97.545.151-.09c.212-.122.424-.213.667-.273l.151-.061.334-1.06h.848l.333 1.06.152.06c.212.061.424.152.636.273l.152.091 1-.545.606.606-.546 1 .091.151c.122.212.213.425.273.637l.03.151 1.091.334v.848z"></path>
      </g>
      <defs>
        <clipPath id="clip0_32394_12773">
          <path
            fill="#fff"
            d="M0 0H10V10H0z"
            transform="translate(13 14)"></path>
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
